import { supabase } from "./supabase";

/**
 * Save the browser time zone only when the account does not have one yet.
 * A later change in Settings is kept. 9:00 stays 9:00.
 */
export function fillTimezoneIfEmpty(userId: string): void {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!timezone) return;
  void supabase
    .from("user_preferences")
    .select("timezone")
    .eq("user_id", userId)
    .maybeSingle()
    .then(async ({ data, error }) => {
      if (error || data?.timezone) return;
      const write = data
        ? supabase
            .from("user_preferences")
            .update({ timezone, updated_at: new Date().toISOString() })
            .eq("user_id", userId)
            .is("timezone", null)
        : supabase.from("user_preferences").insert({
            user_id: userId,
            timezone,
            updated_at: new Date().toISOString(),
          });
      const { error: writeError } = await write;
      if (writeError) console.error("Failed to save timezone:", writeError);
    });
}
